export const Content = ({ children, ...rest }) => (
  <div {...rest}>{children}</div>
);
